import { 
    SET_LOADING,
    APPEND_ALL_APPLICANTS_LIST,
    APPEND_FINAL_APPLICANTS_LIST,
    APPEND_SHORTLISTED_APPLICANTS_LIST,
    SET_ALL_APPLICANTS_LIST,
    SET_ALL_APPLICANTS_LIST_META,
    SET_FINAL_APPLICANTS_LIST,
    SET_FINAL_APPLICANTS_LIST_META,
    SET_SHORTLISTED_APPLICANTS_LIST,
    SET_SHORTLISTED_APPLICANTS_LIST_META,
    SET_IS_SELECT_MODE,
    SET_LIST_TYPE,
    SET_SELECTED_APPLICANTS
} from "../../actions/applicants/types";

const INITIAL_STATE = {
    loading: false,
    allApplicantList: [],
    allApplicantListMetaData: {
        loading: false, hasMore: true
    },
    shortlistedApplicantList: [],
    shortlistedApplicantListMetaData: {
        loading: false, hasMore: true
    },
    finalApplicantList: [],
    finalApplicantListMetaData: {
        loading: false, hasMore: true
    },
    listType: 'grid',
    isSelectMode: false,
    selectedApplicants: []
}

const ApplicantsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_ALL_APPLICANTS_LIST: {
            return {
                ...state,
                allApplicantList: action.payload
            }
        }
        case SET_ALL_APPLICANTS_LIST_META: {
            return {
                ...state,
                allApplicantListMetaData: action.payload
            }
        }
        case APPEND_ALL_APPLICANTS_LIST: {
            return {
                ...state,
                allApplicantList: [ ...state.allApplicantList, ...action.payload]
            }
        }
        case SET_SHORTLISTED_APPLICANTS_LIST: {
            return {
                ...state,
                shortlistedApplicantList: action.payload
            }
        }
        case SET_SHORTLISTED_APPLICANTS_LIST_META: {
            return {
                ...state,
                shortlistedApplicantListMetaData: action.payload
            }
        }
        case APPEND_SHORTLISTED_APPLICANTS_LIST: {
            return {
                ...state,
                shortlistedApplicantList: [ ...state.shortlistedApplicantList, ...action.payload]
            }
        }
        case SET_FINAL_APPLICANTS_LIST: {
            return {
                ...state,
                finalApplicantList: action.payload
            }
        }
        case SET_FINAL_APPLICANTS_LIST_META: {
            return {
                ...state,
                finalApplicantListMetaData: action.payload
            }
        }
        case APPEND_FINAL_APPLICANTS_LIST: {
            return {
                ...state,
                finalApplicantList: [ ...state.finalApplicantList, ...action.payload]
            }
        }
        case SET_LIST_TYPE: {
            return {
                ...state,
                listType: action.payload
            }
        }
        case SET_IS_SELECT_MODE: {
            return {
                ...state,
                isSelectMode: action.payload
            }
        }
        case SET_SELECTED_APPLICANTS: {
            return {
                ...state,
                selectedApplicants: action.payload
            }
        }
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        default: {
            return state;
        }
    }
}

export default ApplicantsReducer;